const babel = require('@babel/core');

const babelOptions = {
  'babelrc': false,
  'sourceMaps': true,
  'presets': [
    ['@babel/preset-env', {
      'targets': {
        'ie': '11',
      },
    }],
    ['@babel/preset-typescript', {
      // no idea why we need these, https://github.com/kulshekhar/ts-jest/issues/934#issuecomment-452325193
      'isTSX': true,
      'allExtensions': true,
    }],
    '@babel/preset-react',
  ],
  'plugins': [
    '@babel/plugin-proposal-object-rest-spread',
    ['@babel/plugin-proposal-decorators', {legacy: true}],
    ['@babel/plugin-proposal-class-properties'],
    ['@babel/plugin-syntax-dynamic-import'],
    ['react-loadable/babel'],
  ],
};

module.exports = function compile(code, options = {targetNode: false}) {

  if (options.targetNode) {
    babelOptions.presets[0][1].targets = {node: '8'};
  }
  return babel.transformSync(code, babelOptions);
};
